@if (data()) {
  <div class="confirm-dialog-with-reason">
    <div class="confirm-dialog-with-reason__header">
      <h2 class="confirm-dialog-with-reason__title">{{ data()!.title }}</h2>
    </div>
    <div class="confirm-dialog-with-reason__content">
      <p class="confirm-dialog-with-reason__message">{{ data()!.message }}</p>
      <div class="confirm-dialog-with-reason__reason">
        <htx-textarea-field
          [ctrl]="reasonControl"
          [label]="data()!.reasonLabel || 'Grund'"
          [required]="true"
          [rows]="4">
        </htx-textarea-field>
      </div>
    </div>
    <div class="confirm-dialog-with-reason__actions">
      <htx-button variant="tertiary" (click)="cancel()">
        {{ data()!.cancelText || 'Abbrechen' }}
      </htx-button>
      <htx-button variant="danger" (click)="confirm()" [disabled]="reasonControl.invalid">
        {{ data()!.confirmText || 'Bestätigen' }}
      </htx-button>
    </div>
  </div>
}
